export default __webpack_public_path__ + "static/MaisonMono-Bold-cf47014334f293e47117a0e1d1d21678.woff2";